import { ActivityReport } from "../../adapters/activityReport";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(activityReport: ActivityReport): Interactor {
  return () => {
    return present(activityReport.send());
  };
}

export type { Interactor };

export { createInteractor };
